import * as React from "react";

import UserDetailTopBar from "./Ops.Users.UserDetailTopBar";

import { groupAuth } from "app/utils/authGroups";

import {
  DetailsContainer,
  DeviceListContainer,
  BankCardListContainer,
  WalletListContainer,
} from "app/components/AppComponents/Users";

import { match } from "react-router-dom";

const hasWalletAccess = groupAuth.hasAccessGroup([
  "Wallet/Staff",
  "Wallet/Admin",
]);

type Props = {
  match: match<{ id: string }>;
  setHeader: (data: { title: string; description: string }) => void;
};

type State = {
  authedBankCardLoads: string;
  deviceCount: number;
};

class Summary extends React.Component<Props, State> {
  state = {
    authedBankCardLoads: "/",
    deviceCount: 0,
  };

  render() {
    const { authedBankCardLoads, deviceCount } = this.state;
    return (
      <React.Fragment>
        <UserDetailTopBar />
        <section className="padded scrollable">
          <div>
            <DetailsContainer
              external_reference={this.props.match.params.id}
              authedBankCardLoads={authedBankCardLoads}
              deviceCount={deviceCount}
              onUserChanged={(user) => {
                this.props.setHeader({
                  title: `Ops > ${user.email}`,
                  description: "Summary of user",
                });
              }}
            />
            <DeviceListContainer
              external_reference={this.props.match.params.id}
              onDeviceCountChanged={(deviceCount) => {
                this.setState({ deviceCount });
              }}
            />
            <BankCardListContainer
              external_reference={this.props.match.params.id}
              onAuthedBankCardLoadsSet={(authedBankCardLoads) => {
                this.setState({ authedBankCardLoads });
              }}
            />

            {hasWalletAccess ? (
              <WalletListContainer
                external_reference={this.props.match.params.id}
              />
            ) : null}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Summary;
